import { debounce } from './func-perf';

export function lazyload(dom, cb, options = {}) {
  if (!dom) return null;

  const defaultOptions = {
    delay: 300, // 函数的debounce延时
    threshold: 500, // 距离目标多远触发
    once: true,
  };

  const resultOptions = Object.assign({}, defaultOptions, options);

  function handler() {
    const viewportHeight = window.innerHeight;
    const rect = dom.getBoundingClientRect() || { top: 0 };
    // 出现在视口中
    if (rect.top < resultOptions.threshold + viewportHeight) {
      cb(dom);
      if (resultOptions.once) {
        window.removeEventListener('scroll', delayedHandler);
      }
    }
  }
  const delayedHandler = debounce(handler, resultOptions.delay);

  window.addEventListener('scroll', delayedHandler);
}

/**
 * 判断dom是否出现在视口中
 * @param {HTMLElement} $dom
 */
export function isInViewport($dom, options = {}) {
  const defaultOptions = {
    ratio: 0.5, // 当在视口的高度 > 元素高度 * ratio的时候才算在是口中
  };

  const resultOptions = Object.assign(defaultOptions, options);

  if (!$dom) return false;

  const bRect = $dom.getBoundingClientRect();

  const { height, top, bottom } = bRect;
  const viewportHeight = window.innerHeight; // 视口高度

  // dom没有显示
  if (height === 0) return false;

  // 没有在视口中
  if (bottom < 0 || top > viewportHeight) return false;

  // 完全在视口中
  if (
    (viewportHeight - bottom > 0 && top > 0) ||
    (top < 0 && bottom > viewportHeight)
  )
    return true;

  // 局部-上部分被隐藏
  let partHeight = 0;
  if (top < 0) {
    partHeight = bottom;
    // 局部-下部分被隐藏
  } else {
    partHeight = viewportHeight - top;
  }

  // 展示部分超过height * ratio才算是展示在视口
  if (partHeight >= height * resultOptions.ratio) return true;

  return false;
}

/**
 * 判断dom是否含有_clsName的样式
 * @param {HTMLElement} $dom
 * @param {String} _clsName
 */
export function hasClassName($dom, _clsName) {
  const clsList = $dom.getAttribute('class').split(/\s/);
  return clsList.indexOf(_clsName) > -1;
}

export function insertAfter($newElement, $target) {
  const $parentNode = $target.parentElement;
  const $targetNext = $target.nextSibling;

  if ($targetNext) {
    $parentNode.insertBefore($newElement, $targetNext);
  } else {
    $parentNode.appendChild($newElement);
  }
}
